/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SendReplacementDialog.vue?vue&type=template&id=5eb480fe"
import script from "./SendReplacementDialog.vue?vue&type=script&lang=js"
export * from "./SendReplacementDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5eb480fe')) {
      api.createRecord('5eb480fe', component.options)
    } else {
      api.reload('5eb480fe', component.options)
    }
    module.hot.accept("./SendReplacementDialog.vue?vue&type=template&id=5eb480fe", function () {
      api.rerender('5eb480fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/SendReplacementDialog.vue"
export default component.exports